export default __webpack_public_path__ + "static/entwicklung-7dd9e17187e5876fe6e34be4e3284768.webp";